<!-- 组织操作 -->
<template>
    <div>
        <el-drawer :close-on-press-escape="true" :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" :with-header="false" :append-to-body="true" :direction="dataActionBox.openMode" size="100%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs style="margin-bottom: 50px;" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form size="mini" inline label-width="130px" lalel-width="160px">
                                        <el-form-item label="组织名称" prop="ormName">
                                            <label slot="label" :style="$common.labelStyle('组织名称')" v-html="'组织名称'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.ormName" placeholder="组织名称"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="组织编码" prop="ormCode">
                                            <label slot="label" :style="$common.labelStyle('组织编码')" v-html="'组织编码'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.ormCode"  placeholder="选择组织归属后可自动生成" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="日期查询间隔天数" prop="days">
                                            <label slot="label" :style="$common.labelStyle('日期查询间隔天数')" v-html="'日期查询间隔天数'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.days" placeholder="日期查询间隔天数"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="发货地址" prop="deliveryAddress">
                                            <label slot="label" :style="$common.labelStyle('发货地址')" v-html="'发货地址'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.deliveryAddress" placeholder="发货地址"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="委托经办人" prop="entrustAgent">
                                            <label slot="label" :style="$common.labelStyle('委托经办人')" v-html="'委托经办人'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.entrustAgent" placeholder="委托经办人"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="省市区" prop="addressP">
                                            <el-cascader class="form_codition" @change="handleChange" style="width:100%" :options="optionsList" v-model="sendDataInfo.addressP">
                                            </el-cascader>
                                        </el-form-item>
                                        <el-form-item label="联系人" prop="contactPerson">
                                            <label slot="label" :style="$common.labelStyle('联系人')" v-html="'联系人'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.contactPerson" placeholder="联系人"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="联系电话" prop="contactPhone">
                                            <label slot="label" :style="$common.labelStyle('联系电话')" v-html="'联系电话'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.contactPhone" placeholder="联系电话"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="T+地址" prop="turl">
                                            <label slot="label" :style="$common.labelStyle('T+地址')" v-html="'T+地址'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.turl" placeholder="T+地址"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="T+地址2" prop="turl2">
                                            <label slot="label" :style="$common.labelStyle('T+地址2')" v-html="'T+地址2'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.turl2" placeholder="T+地址2"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="信用审批" prop="isCredit">
                                            <label slot="label" :style="$common.labelStyle('信用审批')" v-html="'信用审批'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isCredit" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否月初" prop="isBeginmonhe">
                                            <label slot="label" :style="$common.labelStyle('是否月初')" v-html="'是否月初'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isBeginmonhe" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="同步wms" prop="isSynwms">
                                            <label slot="label" :style="$common.labelStyle('同步wms')" v-html="'同步wms'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isSynwms" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="传wms时机" prop="wmsStep">
                                            <label slot="label" :style="$common.labelStyle('传wms时机')" v-html="'传wms时机'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.wmsStep" size="mini">
                                                <el-option v-for="(item, keys) in options2" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="协同需要审批" prop="isSynergy">
                                            <label slot="label" :style="$common.labelStyle('协同需要审批')" v-html="'协同需要审批'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isSynergy" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="启用wms字段" prop="isEnablewms">
                                            <label slot="label" :style="$common.labelStyle('启用wms字段')" v-html="'启用wms字段'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isEnablewms" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="强制匹配资料库" prop="isMatch">
                                            <label slot="label" :style="$common.labelStyle('强制匹配资料库')" v-html="'强制匹配资料库'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isMatch" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="销售订单审核流程" prop="isSuaudit">
                                            <label slot="label" :style="$common.labelStyle('销售订单审核流程')" v-html="'销售订单审核流程'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isSuaudit" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="首营自动生成编号" prop="isSygencode">
                                            <label slot="label" :style="$common.labelStyle('首营自动生成编号')" v-html="'首营自动生成编号'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isSygencode" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="价格金额信息拦截" prop="isIntercept">
                                            <label slot="label" :style="$common.labelStyle('价格金额信息拦截')" v-html="'价格金额信息拦截'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isIntercept" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="付款扣货主手续费" prop="isBankcharges">
                                            <label slot="label" :style="$common.labelStyle('付款扣货主手续费')" v-html="'付款扣货主手续费'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isBankcharges" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否必选采购合同" prop="isPucontrol">
                                            <label slot="label" :style="$common.labelStyle('是否必选采购合同')" v-html="'是否必选采购合同'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isPucontrol" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否必选销售合同" prop="isSucontrol">
                                            <label slot="label" :style="$common.labelStyle('是否必选销售合同')" v-html="'是否必选销售合同'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isSucontrol" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否管理对方业务员" prop="isSales">
                                            <label slot="label" :style="$common.labelStyle('是否管理对方业务员')" v-html="'是否管理对方业务员'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isSales" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否管理业务员" prop="isOpm">
                                            <label slot="label" :style="$common.labelStyle('是否管理业务员')" v-html="'是否管理业务员'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isOpm" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="认款是否自动记账" prop="isAutoaccept">
                                            <label slot="label" :style="$common.labelStyle('认款是否自动记账')" v-html="'认款是否自动记账'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isAutoaccept" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="提现是否扣手续费" prop="isProcedure">
                                            <label slot="label" :style="$common.labelStyle('提现是否扣手续费')" v-html="'提现是否扣手续费'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isProcedure" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="授权时间" prop="authDate">
                                            <div class="sqTime">
                                                <el-date-picker v-model="sendDataInfo.authDate" type="date" placeholder="授权时间" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                                                </el-date-picker>
                                            </div>
                                        </el-form-item>
                                        <el-form-item label="是否启用货位" prop="isSl">
                                            <label slot="label" :style="$common.labelStyle('是否启用货位')" v-html="'是否启用货位'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isSl" size="mini">
                                                <el-option v-for="(item, keys) in options3" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="合同是否审核" prop="isContractaudit">
                                            <label slot="label" :style="$common.labelStyle('合同是否审核')" v-html="'合同是否审核'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isContractaudit" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否拣货" prop="isPick">
                                            <label slot="label" :style="$common.labelStyle('是否拣货')" v-html="'是否拣货'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isPick" size="mini">
                                                <el-option v-for="(item, keys) in options3" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="销售外部订单审核" prop="isSuwithout">
                                            <label slot="label" :style="$common.labelStyle('销售外部订单审核')" v-html="'销售外部订单审核'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isSuwithout" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否默认业务员" prop="isDefaultopm">
                                            <label slot="label" :style="$common.labelStyle('是否默认业务员')" v-html="'是否默认业务员'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isDefaultopm" size="mini">
                                                <el-option v-for="(item, keys) in options3" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="组织编码规则" prop="codeRule">
                                            <label slot="label" :style="$common.labelStyle('组织编码规则')" v-html="'组织编码规则'"></label>
                                            <el-input class="form_codition" @input="validateInput" v-model="sendDataInfo.codeRule" placeholder="组织编码规则"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="统一社会信用代码" prop="socialcode">
                                            <label slot="label" :style="$common.labelStyle('统一社会信用代码')" v-html="'统一社会信用代码'"></label>
                                            <el-input class="form_codition"  v-model="sendDataInfo.socialcode" placeholder="统一社会信用代码"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="验收是否核价" prop="priceVerify">
                                            <label slot="label" :style="$common.labelStyle('验收是否核价')" v-html="'验收是否核价'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.priceVerify" size="mini">
                                                <el-option v-for="(item, keys) in options3" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="医院是否必填" prop="isMustHospital">
                                            <label slot="label" :style="$common.labelStyle('医院是否必填')" v-html="'医院是否必填'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isMustHospital" size="mini">
                                                <el-option v-for="(item, keys) in options3" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="电子监管码单位名称" prop="wesName">
                                            <label slot="label" :style="$common.labelStyle('电子监管码单位名称')" v-html="'电子监管码单位名称'"></label>
                                            <el-input class="form_codition" v-model="sendDataInfo.wesName" placeholder="电子监管码单位名称"  clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="是否使用水印" prop="isWatermark">
                                            <label slot="label" :style="$common.labelStyle('是否使用水印')" v-html="'是否使用水印'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isWatermark" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <template v-if="sendDataInfo.isWatermark == 'true'">
                                                <div class="watermark-upload-wrapper">
                                                    <el-upload class="avatar-uploader" :headers="uploadHeader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess">
                                                        <el-image v-if="sendDataInfo.fileUrl" style="width: 80px; height: 80px" fit="cover" :src="`${imgUrl}/${sendDataInfo.fileUrl}`" :preview-src-list="[`${imgUrl}/${sendDataInfo.fileUrl}`]">
                                                        </el-image>
                                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                    </el-upload>
                                                    <el-button v-if="sendDataInfo.fileUrl" type="danger" size="mini" class="watermark-delete-btn" icon="el-icon-delete" @click="deleteWatermark">
                                                        删除
                                                    </el-button>
                                                </div>
                                            </template>
                                        </el-form-item>
                                        <el-form-item label="是否上传证照添加水印" prop="isLicenceWatermark">
                                            <label slot="label" :style="$common.labelStyle('是否上传证照添加水印')" v-html="'是否上传证照添加水印'"></label>
                                            <el-select class="form_codition" v-model="sendDataInfo.isLicenceWatermark" size="mini">
                                                <el-option v-for="(item, keys) in options1" :key="keys" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <template v-if="sendDataInfo.isLicenceWatermark == 'true'">
                                                <div class="watermark-upload-wrapper">
                                                    <el-upload class="avatar-uploader" :headers="uploadHeader" :action="uploadUrl" :show-file-list="false" :on-success="handleLicenceWatermarkSuccess">
                                                        <el-image v-if="sendDataInfo.licenceWatermarkUrl" style="width: 80px; height: 80px" fit="cover" :src="`${imgUrl}/${sendDataInfo.licenceWatermarkUrl}`" :preview-src-list="[`${imgUrl}/${sendDataInfo.licenceWatermarkUrl}`]">
                                                        </el-image>
                                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                    </el-upload>
                                                    <el-button v-if="sendDataInfo.licenceWatermarkUrl" type="danger" size="mini" class="watermark-delete-btn" icon="el-icon-delete" @click="deleteLicenceWatermark">
                                                        删除
                                                    </el-button>
                                                </div>
                                            </template>
                                        </el-form-item>
                                    </el-form>
                                </div>

                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
                    <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
 
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { regionData} from 'element-china-area-data'
export default {
    name: "organizationActions",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            showTabs: '',
            formDataList: [],
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            optionsList: regionData,
            sendDataInfo: {
                socialcode:"",
                days: 3,
                addressP: [],
                ormCode: "",
                ormName: "",
                ormParentid: "",
                ormId: "",
                deliveryAddress: "",
                entrustAgent: "",
                contactPerson: "",
                contactPhone: "",
                isSynwms: "",
                isSuaudit: "",
                isSygencode: "",
                isSynergy: "",
                isCredit: "",
                isIntercept: "",
                wmsStep: "",
                isBankcharges: "",
                isBeginmonhe: "",
                isEnablewms: "",
                turl: "",
                turl2: "",
                isMatch: "",
                isPucontrol: "",
                isSucontrol: "",
                ormProvince: '',
                ormCity: '',
                ormArea: '',
                isSales: '',
                isOpm: '',
                isAutoaccept: '',
                isProcedure: '',
                authDate: "",
                isSl: '',
                isContractaudit: '',
                isPick: '',
                isSuwithout: '',
                isMustHospital:"",
                wesName:"",
                isDefaultopm: "",
                priceVerify:"",
                isWatermark:'false',
                fileUrl: "",
                isLicenceWatermark: 'false',
                licenceWatermarkUrl: "",
                codeRule: ""
            },
            allorgList: [],
            selectOrgPath: 0,
            selectedDataList: [],
            typeList: [],
            options1: [
                {
                    value: "true",
                    label: "是",
                },
                {
                    value: "false",
                    label: "否",
                },
            ],
            options2: [
                {
                    value: "order",
                    label: "订单",
                },
                {
                    value: "receipt",
                    label: "收货",
                },
                {
                    value: "accept",
                    label: "验收",
                },
            ],
            options3: [
                {
                    value: 0,
                    label: "否",
                },
                {
                    value: 1,
                    label: "是",
                },
            ],
            imgUrl: window.global_config.BASE_IMG_URL,
            uploadUrl: window.global_config.BASE_URL + '/upload/fileupload',
            uploadHeader: {
                token: sessionStorage.getItem('token')
            },
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        //组织编码规则
        validateInput(e) {
            if (e !== '') {
                if (e.length > 3) {
                    this.sendDataInfo.codeRule = ''
                    this.$message.warning("长度不允许超过三位！")
                }
                if (!this.isAlphanumeric(e)) {
                     this.sendDataInfo.codeRule = ''
                    this.$message.warning("只允许数字和字母！")
                }
            }


        },
        isAlphanumeric(str) {
            return /[a-zA-Z0-9]+$/.test(str);
        },
        handleAvatarSuccess(res, file) {
            if (res.status == 200) {
                this.sendDataInfo.fileUrl = res.result[0].fileUrl;
                this.$message.success("上传成功");
            } else {
                this.$message.error(res.message);
            }
        },
        deleteWatermark() {
            this.$confirm("确定要删除水印图片吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.sendDataInfo.fileUrl = "";
                this.$message.success("删除成功");
            }).catch(() => {});
        },
        handleLicenceWatermarkSuccess(res, file) {
            if (res.status == 200) {
                this.sendDataInfo.licenceWatermarkUrl = res.result[0].fileUrl;
                this.$message.success("上传成功");
            } else {
                this.$message.error(res.message);
            }
        },
        deleteLicenceWatermark() {
            this.$confirm("确定要删除证照水印图片吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.sendDataInfo.licenceWatermarkUrl = "";
                this.$message.success("删除成功");
            }).catch(() => {});
        },
        // 生成组织编码
        async createOrgCode(superiorCode = "", pid) {
            if (pid == -1) {
                pid = 0;
            }
            var list = await this.getALLOrgData();
            var sonList = this.getSubTree(list, pid, 0);
            var sonLength = sonList.length + 1;
            var returnCode =
                superiorCode +
                (sonLength / 10 < 1
                    ? sonLength.toString().padStart(2, "0")
                    : sonLength);
            if (pid == 0) {
                returnCode =
                    "A" +
                    (sonLength / 10 < 1
                        ? sonLength.toString().padStart(2, "0")
                        : sonLength);
            }
            return returnCode;
        },

        //$data array  待分类的数据--- $id  int/string     要找的子节点id--- $lev  int  节点等级
        getSubTree(data, id = 0, lev = 0, selectId = "") {
            var son = [];
            data.forEach((value, keys) => {
                // if (selectId == value['ormId']) {
                //     value['disabled'] = true;
                // }
                if (value["ormParentid"] == id) {
                    value["value"] = value["ormId"];
                    value["label"] = value["ormName"];
                    value["lev"] = lev;
                    var list = this.getSubTree(data, value["ormId"], lev + 1);
                    if (list.length >= 1) {
                        value["children"] = this.getSubTree(
                            data,
                            value["ormId"],
                            lev + 1
                        );
                    }
                    son.push(value);
                }
            });
            return son;
        },
        handleChange(val) {
            this.sendDataInfo.ormProvince = regionData[regionData.findIndex(item => item.value == val[0])].label
            this.sendDataInfo.ormCity = regionData[regionData.findIndex(item => item.value == val[0])].children[regionData[regionData.findIndex(item => item.value == val[0])].children.findIndex(item => item.value == val[1])].label
            this.sendDataInfo.ormArea = regionData[regionData.findIndex(item => item.value == val[0])].children[regionData[regionData.findIndex(item => item.value == val[0])].children.findIndex(item => item.value == val[1])].children[regionData[regionData.findIndex(item => item.value == val[0])].children[regionData[regionData.findIndex(item => item.value == val[0])].children.findIndex(item => item.value == val[1])].children.findIndex(item => item.value == val[2])].label
        },
        async getALLOrg() {
            var initArr = [
                {
                    value: -1,
                    label: "一级组织",
                    ormCode: "",
                    ormParentid: 0,
                    children: [],
                },
            ];
            initArr[0].children = await this.getALLOrgC();
            this.allorgList = initArr;
        },
        // 获取全部组织
        async getALLOrgC(selectId = "") {
            var list = [];
            let requestData = await this.$http.getALLOrg();
            if (requestData && requestData.status == 200) {
                list = this.getSubTree(requestData.result.ormList, 0, 0, selectId);
            } else {
                this.$message({
                    type: "error",
                    message: requestData.message,
                });
            }
            return list;
        },
        // 获取全部组织
        async getALLOrgData() {
            var list = [];
            let requestData = await this.$http.getALLOrg();
            if (requestData && requestData.status == 200) {
                list = requestData.result.ormList;
            } else {
                this.$message({
                    type: "error",
                    message: requestData.message,
                });
            }
            return list;
        },
        async selectPath() {
            var newData = this.$refs.ormParentid.getCheckedNodes(true);

            if (newData[0] == null) {
                var codes = await this.createOrgCode(
                    this.allorgList[0].ormCode,
                    this.allorgList[0].value
                );
            } else {
                var codes = await this.createOrgCode(
                    newData[0].data.ormCode,
                    newData[0].data.value
                );
            }
            this.sendDataInfo.ormParentid = this.selectOrgPath.slice(-1)[0];
            if (this.selectOrgPath == -1) {
                this.sendDataInfo.ormParentid = 0;
            }
            this.sendDataInfo.ormCode = codes;
        },

        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.ormParentid = 0;
            this.sendDataInfo.days = 3;
            this.dataActionBox.actionType = 0;
            this.dataActionBox.showStatus = false;
        },

        // 获取类型列表
        async getTypeList() {
            let responseData = await this.$http.getCateDictionariesData({ ids: [18] });
            if (responseData.status == 200) {
                this.typeList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        async openBox(cate, oldData = "") {
            this.initActionBox();
            this.getALLOrg();
            this.getTypeList();
            this.selectOrgPath = -1;
            this.sendDataInfo.ormCode = await this.createOrgCode(
                "",
                this.selectOrgPath
            );
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.showTabs = "新增组织"
                this.formDataList = [
                    {
                        jciName: "新增组织",
                        jurconfigform: [],
                    }
                ]
            } else {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "ltr";
                this.sendDataInfo.addressP = []
                this.showTabs = "编辑组织"
                this.formDataList = [
                    {
                        jciName: "编辑组织",
                        jurconfigform: [],
                    }
                ]

                if (oldData.ormProvince) {
                    this.sendDataInfo.addressP.push(regionData[regionData.findIndex(item => item.label == oldData.ormProvince)]?.value)
                    this.sendDataInfo.addressP.push(regionData[regionData.findIndex(item => item.label == oldData.ormProvince)]?.children[regionData[regionData.findIndex(item => item.label == oldData.ormProvince)]?.children.findIndex(item => item.label == oldData.ormCity)]?.value)
                    const list = regionData[regionData.findIndex(item => item.label == oldData.ormProvince)]?.children[regionData[regionData.findIndex(item => item.label == oldData.ormProvince)]?.children.findIndex(item => item.label == oldData.ormCity)]?.children
                    this.sendDataInfo.addressP.push(list[list.findIndex(item => item.label == oldData.ormArea)]?.value)
                }
                console.log(this.sendDataInfo.addressP);
                for (let key in oldData) {
                    if (key == 'days' && oldData[key] == null) {
                        this.sendDataInfo[key] = 3

                    } else {
                        this.sendDataInfo[key] = oldData[key];
                    }
                }
            }
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
        },
        async sendDataAction() {
            if (this.sendDataInfo.ormCode == "") {
                this.$message({
                    message: "请填写编码",
                    type: "error",
                });
                return false;
            }
            if (this.sendDataInfo.ormName == "") {
                this.$message({
                    message: "请填写名称",
                    type: "error",
                });
                return false;
            }
            var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addOrganization(sendDataInfo);
            } else {
                var responseData = await this.$http.setOrganization(sendDataInfo);
            }
            if (responseData.status == 200) {
                this.initActionBox();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });

                this.$emit("closeAction");
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.watermark-upload-wrapper {
    display: flex;
    align-items: center;
    margin-left: 10px;
}
::v-deep .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
::v-deep .avatar-uploader:hover {
    border-color: #409eff;
}
::v-deep .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.watermark-delete-btn {
    margin-left: 10px;
}
</style>